// NATIVE 

// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";
import { QueryPagination } from "../commons/interfaces";
import { buildQuery } from "../commons/utils/helpers";

const http = new AxiosAdapter();

export const getCustomerOptionsService = async () => {
    try {
        return await http.get<any>(`/v1/services-ia-usage-dailys/form`);
    } catch (error: any) {
        if (error && !error.ok) return error; 
        console.log('getCustomerOptionsService ', error);
    }
}


export const getServicesIaUsageDailysAnalyticsService = async (query?: any) => {
    try {
        // Filter out undefined, null, or empty string values
        const validParams = Object.entries(query || {}).filter(([_, value]) => value !== undefined && value !== null && value !== '');
        const queryString = new URLSearchParams(validParams as string[][]).toString();
        
        return await http.get<any>(`/v1/services-ia-usage-dailys/analytics${queryString ? `?${queryString}` : ''}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getServicesIaUsageDailysAnalyticsService ', error);
    }
}
